import type { ReactNode } from "react";
import { memo } from "react";
import { Box } from "@mui/material";

type SquareImageProps = {
  image: string;
  width?: string;
  height?: string;
  withBackground?: boolean;
  isArticleActif?: boolean;
};

const backgroundStyle = {
  borderRadius: "100%",
  backgroundColor: "#E0F3F8",
  backgroundPosition: "center",
  width: "80%",
  height: "80%",
  margin: "10%",
  position: "absolute",
  top: 0,
  left: 0,
};

const SquareImage = memo(function SquareImage({
  image,
  width = "140px",
  height = width,
  withBackground = true,
  isArticleActif = true,
}: Readonly<SquareImageProps>): ReactNode {
  return (
    <Box sx={{ position: "relative", width, height, opacity: isArticleActif ? 1 : 0.25 }}>
      {withBackground && <Box sx={backgroundStyle} />}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundImage: `url("${image}")`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      />
    </Box>
  );
});

export default SquareImage;
